<div class="body grid-content-2" [formGroup]="formGroup">

    <div>
        <mat-form-field class="salutation" [appearance]="appearance">

            <mat-label class="label">Anrede</mat-label>
            <input formControlName="contactperssalutation" matInput [readonly]="!editMode"
                [matAutocomplete]="salutationAutocomplete" />

            <button mat-icon-button matSuffix [disabled]="!editMode || !salutationControl.value" color="warn"
                (click)="clearSalutation()">
                <mat-icon>clear</mat-icon>
            </button>

            <mat-autocomplete #salutationAutocomplete="matAutocomplete">

                <mat-option *ngFor="let salutation of salutations" [value]="salutation">
                    {{salutation}}
                </mat-option>

            </mat-autocomplete>

        </mat-form-field>

        <mat-form-field class="width" [appearance]="appearance">

            <mat-label class="label">Nummer</mat-label>
            <input formControlName="contactperspublicid" matInput placeholder="7-stellige Nummer"
                [readonly]="!editMode" />

            <div matSuffix>

                <button mat-icon-button *ngIf="editMode && !publicIdControl.value" (click)="generateNumber()">
                    <mat-icon>adb</mat-icon>
                </button>

                <button mat-icon-button [disabled]="!editMode || !publicIdControl.value" color="warn" (click)="clearNumber()">
                    <mat-icon>clear</mat-icon>
                </button>

            </div>

        </mat-form-field>
    </div>

    <div class="flex-wrapper">
        <mat-form-field [appearance]="appearance">

            <mat-label class="label">Vorname</mat-label>
            <input formControlName="contactpersfname" matInput placeholder="z.B. Max" [readonly]="!editMode" />

            <button mat-icon-button matSuffix [disabled]="!editMode || !firstNameControl.value" color="warn"
                (click)="clearFirstname()">
                <mat-icon>clear</mat-icon>
            </button>

        </mat-form-field>
    </div>

    <div class="flex-wrapper">
        <mat-form-field class="width" [appearance]="appearance">

            <mat-label class="label">Nachname</mat-label>
            <input formControlName="contactperslname" matInput placeholder="z.B. Mustermann" [readonly]="!editMode" />

            <button mat-icon-button matSuffix [disabled]="!editMode || !surnameControl.value" color="warn"
                (click)="clearSurname()">
                <mat-icon>clear</mat-icon>
            </button>

        </mat-form-field>
    </div>

    <ng-container *ngIf="doubletService && (doubletService.checkerVisible$|async)">

        <app-doublet-checker></app-doublet-checker>

    </ng-container>

    <div class="flex-wrapper">
        <mat-form-field class="width" [appearance]="appearance">

            <mat-label class="label">Abteilung</mat-label>
            <input formControlName="contactpersondepartment" matInput placeholder="z.B. Geschäftsführung"
                [readonly]="!editMode" [matAutocomplete]="departmentAutoComplete" />

            <button mat-icon-button matSuffix [disabled]="!editMode || !departmentControl.value" color="warn"
                (click)="clearDepartment()">
                <mat-icon>clear</mat-icon>
            </button>

        </mat-form-field>
    </div>

</div>

<mat-autocomplete #departmentAutoComplete="matAutocomplete">

    <ng-container *ngIf="departmentsProviderService">

        <div *ngFor="let department of (departmentsProviderService.departments$|async)">
            <mat-option [value]="department">
                {{department}}
            </mat-option>
        </div>

        <div class="load-more-departments" *ngIf="departmentsProviderService.hasMoreDepartments$|async"
            (click)="departmentsProviderService.loadMoreDepartments()">
            Mehr laden
        </div>

    </ng-container>

</mat-autocomplete>